import React, { FC } from 'react'

import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import EmployerRateCardList, {
  EmployerRateCardTrackingProvider,
} from 'syft-acp-core/entities/EmployerDetail/EmployerRateCardList'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{
  id: string
}>

const NewEmployerRateCardList: FC<Props> = ({ match: { params } }: Props) => {
  const employerID = Number(params.id)
  const employerName = useEmployerName(employerID)

  return (
    <PageTitle title={['Rate cards', recordLabel('Employer', params.id, employerName)]}>
      <div className="page entity-list">
        <SubNavigation subPage="employers" data={{ employerID }} />
        <EmployerRateCardTrackingProvider employerId={employerID}>
          <EmployerRateCardList
            employerID={employerID}
            query={{ employer_ids: [employerID] }}
            urlBase={`/entity/employers/view/${params.id}/ratecards-v2/view/`}
          />
        </EmployerRateCardTrackingProvider>
      </div>
    </PageTitle>
  )
}

export default NewEmployerRateCardList
